(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blitz-box-order"]) return;
  try {
    
if (!customElements.get('blitz-box-order')) {
  customElements.define('blitz-box-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.rows = Array.from(this.querySelectorAll('[data-box-product]'));
      this.byVariant = new Map(this.rows.map(row => [Number(row.dataset.variant), row]));
      this.cart = {items: [], total_price: 0, currency: this.dataset.currency || 'MXN'};
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.busy = false;
      this.ready = false;
      this.money = value => new Intl.NumberFormat((document.documentElement.lang || 'es-MX').toLowerCase().startsWith('es') ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.cart.currency || 'MXN'}).format(value / 100);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity]')) {
          event.target.value = Math.min(999, Math.max(0, Math.floor(Number(event.target.value) || 0)));
          this.render();
        }
      });
      this.render();
      this.refreshCart().catch(() => this.status(this.labels.error));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'blitz-box-order') this.refreshCart().catch(() => this.status(this.labels.error));
        });
      }
      this.pageShow = () => this.refreshCart().catch(() => this.status(this.labels.error));
      window.addEventListener('pageshow', this.pageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShow);
    }
    status(message) { this.querySelector('[data-status]').textContent = message; }
    boxLabel(count) { return count === 1 ? this.labels.box : this.labels.boxes; }
    countLabel(label, count) { return label.replace('[count]', String(count)).replace('[boxes]', this.boxLabel(count)); }
    quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
    existing(row) {
      return this.cart.items.filter(item => Number(item.variant_id) === Number(row.dataset.variant)).reduce((sum, item) => sum + item.quantity, 0);
    }
    async refreshCart() {
      const response = await fetch(this.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cart = await response.json();
      this.ready = true;
      this.renderCart();
      this.render();
    }
    render() {
      let boxes = 0, rolls = 0, subtotal = 0, selected = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        boxes += total;
        selected += qty;
        rolls += total * Number(row.dataset.rolls);
        subtotal += total * Number(row.dataset.price);
        if (qty > 0 && total > Number(row.dataset.stock)) invalid = true;
      });
      const percent = boxes >= 10 ? 10 : boxes >= 5 ? 5 : 0;
      let savings = 0;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        const rowAmount = total * Number(row.dataset.price);
        savings += Math.round(rowAmount * percent / 100);
        const amount = qty * Number(row.dataset.price);
        const payable = amount - Math.round(amount * percent / 100);
        const casePrice = Number(row.dataset.price);
        const discountedCase = casePrice - Math.round(casePrice * percent / 100);
        row.classList.toggle('is-selected', qty > 0 || existing > 0);
        row.querySelector('[data-unit-price]').textContent = this.money(discountedCase / Number(row.dataset.rolls));
        row.querySelector('[data-box-price]').textContent = this.money(discountedCase);
        row.querySelector('[data-unit-regular]').textContent = this.money(casePrice / Number(row.dataset.rolls));
        row.querySelector('[data-unit-regular]').hidden = percent === 0;
        row.querySelector('[data-unit-discount]').textContent = '−' + percent + '%';
        row.querySelector('[data-unit-discount]').hidden = percent === 0;
        row.querySelector('[data-line-total]').hidden = qty === 0;
        row.querySelector('[data-line-count]').textContent = qty + ' ' + this.boxLabel(qty) + ' · ' + qty * Number(row.dataset.rolls) + ' ' + this.labels.rolls;
        row.querySelector('[data-line-price]').textContent = this.money(payable);
        const selectedPreset = qty >= 10 ? 10 : qty >= 5 ? 5 : qty > 0 ? 1 : 0;
        row.querySelectorAll('[data-preset]').forEach(button => {
          const preset = Number(button.dataset.preset);
          const candidateBoxes = boxes - qty + preset;
          const candidatePercent = candidateBoxes >= 10 ? 10 : candidateBoxes >= 5 ? 5 : 0;
          button.setAttribute('aria-pressed', String(selectedPreset === preset));
          const discountLabel = button.querySelector('[data-preset-discount]');
          discountLabel.textContent = candidatePercent ? '−' + candidatePercent + '%' : '';
          discountLabel.hidden = candidatePercent === 0;
          button.setAttribute('aria-label', candidatePercent ? this.countLabel(this.labels.progressText, preset).replace('[percent]', String(candidatePercent)) : preset + ' ' + this.boxLabel(preset));
        });
        const stock = Number(row.dataset.stock);
        const stockMessage = row.querySelector('[data-stock-message]');
        const exceeded = qty > 0 && total > stock;
        stockMessage.classList.toggle('is-error', exceeded);
        stockMessage.textContent = (stock === 0 ? this.labels.outOfStock : exceeded ? this.countLabel(this.labels.available, Math.max(0, stock - existing)) : '') + (existing ? ' ' + this.countLabel(this.labels.inCart, existing) : '');
        stockMessage.hidden = !stockMessage.textContent.trim();
      });
      this.querySelector('[data-selection-count]').textContent = boxes + ' ' + this.boxLabel(boxes) + ' · ' + rolls + ' ' + this.labels.rolls;
      this.querySelector('[data-discount-current]').textContent = percent + '%';
      this.querySelector('[data-mobile-discount]').textContent = boxes + ' ' + this.boxLabel(boxes) + (percent ? ' · −' + percent + '%' : '');
      const progress = this.querySelector('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(boxes, 10)));
      progress.setAttribute('aria-valuetext', this.countLabel(this.labels.progressText, boxes).replace('[percent]', String(percent)));
      this.querySelector('[data-progress-fill]').style.width = Math.min(boxes, 10) * 10 + '%';
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const current = Number(tier.dataset.tier) === percent;
        tier.classList.toggle('is-current', current);
        if (current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      this.querySelector('[data-savings-row]').hidden = percent === 0;

      this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
      this.querySelector('[data-discount-label]').textContent = this.labels.savings + ' (' + percent + '%)';
      this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
      this.querySelector('[data-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-mobile-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-next-tier]').textContent = boxes >= 10 ? this.labels.bestTier : boxes >= 5 ? this.countLabel(this.labels.moreForTen, 10 - boxes) : this.countLabel(this.labels.moreForFive, 5 - boxes);
      this.querySelector('[data-add]').disabled = this.busy || !this.ready || selected === 0 || invalid;
      this.querySelector('[data-checkout]').disabled = this.busy || this.cart.items.length === 0 || selected > 0;
      this.querySelector('[data-pending-note]').hidden = selected === 0;
      this.querySelectorAll('[data-quantity], [data-preset], [data-step]').forEach(control => { control.disabled = this.busy; });
      if (!this.busy && invalid) this.status(this.labels.stockError);
      else if (!this.busy && this.querySelector('[data-status]').textContent === this.labels.stockError) this.status('');
    }
    renderCart() {
      const container = this.querySelector('[data-cart-lines]');
      container.replaceChildren();
      this.cart.items.forEach(item => {
        const row = this.byVariant.get(Number(item.variant_id));
        const line = document.createElement('div');
        line.className = 'box-order__cart-line';
        const title = document.createElement('p');
        title.textContent = item.product_title;
        const quantity = document.createElement('p');
        quantity.textContent = item.quantity + ' ' + (row ? this.boxLabel(item.quantity) + ' · ' + item.quantity * Number(row.dataset.rolls) + ' ' + this.labels.rolls : this.labels.quantity) + ' · ' + this.money(item.final_line_price);
        line.append(title, quantity);
        if (row) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.labels.remove;
          remove.setAttribute('aria-label', this.labels.remove + ': ' + item.product_title);
          line.append(remove);
        }
        container.append(line);
      });
      this.querySelector('[data-cart-panel]').hidden = this.cart.items.length === 0;
      this.querySelector('[data-cart-total]').textContent = this.money(this.cart.total_price);
    }
    async onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const row = button.closest('[data-box-product]');
      if (row && (button.hasAttribute('data-preset') || button.hasAttribute('data-step'))) {
        const value = button.hasAttribute('data-preset') ? Number(button.dataset.preset) : this.quantity(row) + Number(button.dataset.step);
        row.querySelector('[data-quantity]').value = Math.min(999, Math.max(0, value));
        this.status('');
        this.render();
      } else if (button.hasAttribute('data-add')) {
        const items = this.rows.filter(row => this.quantity(row) > 0).map(row => ({id: Number(row.dataset.variant), quantity: this.quantity(row)}));
        if (!items.length || button.disabled) return;
        await this.mutateCart('add', {items});
      } else if (button.hasAttribute('data-remove-key')) {
        await this.mutateCart('change', {id: button.dataset.removeKey, quantity: 0});
      }
    }
    async mutateCart(action, payload) {
      this.busy = true;
      this.status(action === 'add' ? this.labels.adding : this.labels.updating);
      this.render();
      this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.root + 'cart/' + action + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(Object.assign({}, payload, {sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname}))
        });
        const data = await response.json();
        if (action === 'add') this.rows.forEach(row => { row.querySelector('[data-quantity]').value = 0; });
        if (!response.ok) {
          await this.refreshCart();
          throw new Error(data.description || data.message || this.labels.error);
        }
        await this.refreshCart();
        this.updateThemeCart(data.sections);
        this.status(action === 'add' ? this.labels.added : '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'blitz-box-order', cartData: this.cart});
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      } catch (error) {
        this.status(error.message === 'cart' ? this.labels.error : error.message);
      } finally {
        this.busy = false;
        this.render();
        this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = false; });
      }
    }
    updateThemeCart(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const destination = document.getElementById('CartDrawer');
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.toggle('is-empty', this.cart.items.length === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blitz-corte-order"]) return;
  try {
    
if (!customElements.get('blitz-corte-order')) {
  customElements.define('blitz-corte-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.rows = Array.from(this.querySelectorAll('[data-box-product]'));
      this.byVariant = new Map(this.rows.map(row => [Number(row.dataset.variant), row]));
      this.cart = {items: [], total_price: 0, currency: this.dataset.currency || 'MXN'};
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.busy = false;
      this.ready = false;
      this.money = value => new Intl.NumberFormat((document.documentElement.lang || 'es-MX').toLowerCase().startsWith('es') ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.cart.currency || 'MXN'}).format(value / 100);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity]')) {
          event.target.value = Math.min(999, Math.max(0, Math.floor(Number(event.target.value) || 0)));
          this.render();
        }
      });
      this.render();
      this.refreshCart().catch(() => this.status(this.labels.error));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'blitz-corte-order') this.refreshCart().catch(() => this.status(this.labels.error));
        });
      }
      this.pageShow = () => this.refreshCart().catch(() => this.status(this.labels.error));
      window.addEventListener('pageshow', this.pageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShow);
    }
    status(message) { this.querySelector('[data-status]').textContent = message; }
    boxLabel(count) { return count === 1 ? this.labels.box : this.labels.boxes; }
    countLabel(label, count) { return label.replace('[count]', String(count)).replace('[boxes]', this.boxLabel(count)); }
    quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
    existing(row) {
      return this.cart.items.filter(item => Number(item.variant_id) === Number(row.dataset.variant)).reduce((sum, item) => sum + item.quantity, 0);
    }
    async refreshCart() {
      const response = await fetch(this.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cart = await response.json();
      this.ready = true;
      this.renderCart();
      this.render();
      try {
        const sectionsResponse = await fetch(this.root + '?sections=cart-icon-bubble', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
        if (sectionsResponse.ok) this.updateThemeCart(await sectionsResponse.json());
      } catch (error) {}
    }
    render() {
      let boxes = 0, rolls = 0, subtotal = 0, selected = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        boxes += total;
        selected += qty;
        rolls += total * Number(row.dataset.rolls);
        subtotal += total * Number(row.dataset.price);
        if (qty > 0 && total > Number(row.dataset.stock)) invalid = true;
      });
      const percent = boxes >= 10 ? 10 : boxes >= 5 ? 5 : 0;
      let savings = 0;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        const rowAmount = total * Number(row.dataset.price);
        savings += Math.round(rowAmount * percent / 100);
        const amount = qty * Number(row.dataset.price);
        const payable = amount - Math.round(amount * percent / 100);
        const casePrice = Number(row.dataset.price);
        const discountedCase = casePrice - Math.round(casePrice * percent / 100);
        row.classList.toggle('is-selected', qty > 0 || existing > 0);
        row.querySelector('[data-unit-price]').textContent = this.money(discountedCase / Number(row.dataset.rolls));
        row.querySelector('[data-box-price]').textContent = this.money(discountedCase);
        row.querySelector('[data-unit-regular]').textContent = this.money(casePrice / Number(row.dataset.rolls));
        row.querySelector('[data-unit-regular]').hidden = percent === 0;
        row.querySelector('[data-unit-discount]').textContent = '−' + percent + '%';
        row.querySelector('[data-unit-discount]').hidden = percent === 0;
        row.querySelector('[data-line-total]').hidden = qty === 0;
        row.querySelector('[data-line-count]').textContent = qty + ' ' + this.boxLabel(qty) + ' · ' + (qty * Number(row.dataset.rolls)).toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
        row.querySelector('[data-line-price]').textContent = this.money(payable);
        const selectedPreset = total >= 10 ? 10 : total >= 5 ? 5 : total > 0 ? 1 : 0;
        row.querySelectorAll('[data-preset]').forEach(button => {
          const preset = Number(button.dataset.preset);
          const candidateBoxes = boxes - qty + preset;
          const candidatePercent = candidateBoxes >= 10 ? 10 : candidateBoxes >= 5 ? 5 : 0;
          button.setAttribute('aria-pressed', String(selectedPreset === preset));
          const discountLabel = button.querySelector('[data-preset-discount]');
          discountLabel.textContent = candidatePercent ? '−' + candidatePercent + '%' : '';
          discountLabel.hidden = candidatePercent === 0;
          button.setAttribute('aria-label', candidatePercent ? this.countLabel(this.labels.progressText, preset).replace('[percent]', String(candidatePercent)) : preset + ' ' + this.boxLabel(preset));
        });
        const stock = Number(row.dataset.stock);
        const stockMessage = row.querySelector('[data-stock-message]');
        const exceeded = qty > 0 && total > stock;
        stockMessage.classList.toggle('is-error', exceeded);
        stockMessage.textContent = (stock === 0 ? this.labels.outOfStock : exceeded ? this.countLabel(this.labels.available, Math.max(0, stock - existing)) : '') + (existing ? ' ' + this.countLabel(this.labels.inCart, existing) : '');
        stockMessage.hidden = !stockMessage.textContent.trim();
      });
      this.querySelector('[data-selection-count]').textContent = boxes + ' ' + this.boxLabel(boxes) + ' · ' + rolls.toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
      this.querySelector('[data-discount-current]').textContent = percent + '%';
      this.querySelector('[data-mobile-discount]').textContent = boxes + ' ' + this.boxLabel(boxes) + (percent ? ' · −' + percent + '%' : '');
      const progress = this.querySelector('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(boxes, 10)));
      progress.setAttribute('aria-valuetext', this.countLabel(this.labels.progressText, boxes).replace('[percent]', String(percent)));
      this.querySelector('[data-progress-fill]').style.width = Math.min(boxes, 10) * 10 + '%';
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const current = Number(tier.dataset.tier) === percent;
        tier.classList.toggle('is-current', current);
        if (current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      this.querySelector('[data-savings-row]').hidden = percent === 0;

      this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
      this.querySelector('[data-discount-label]').textContent = this.labels.savings + ' (' + percent + '%)';
      this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
      this.querySelector('[data-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-mobile-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-next-tier]').textContent = boxes >= 10 ? this.labels.bestTier : boxes >= 5 ? this.countLabel(this.labels.moreForTen, 10 - boxes) : this.countLabel(this.labels.moreForFive, 5 - boxes);
      this.querySelector('[data-add]').disabled = this.busy || !this.ready || selected === 0 || invalid;
      this.querySelector('[data-checkout]').disabled = this.busy || this.cart.items.length === 0 || selected > 0;
      this.querySelector('[data-pending-note]').hidden = selected === 0;
      this.querySelectorAll('[data-quantity], [data-preset], [data-step]').forEach(control => { control.disabled = this.busy; });
      if (!this.busy && invalid) this.status(this.labels.stockError);
      else if (!this.busy && this.querySelector('[data-status]').textContent === this.labels.stockError) this.status('');
    }
    renderCart() {
      const container = this.querySelector('[data-cart-lines]');
      container.replaceChildren();
      this.cart.items.forEach(item => {
        const row = this.byVariant.get(Number(item.variant_id));
        const line = document.createElement('div');
        line.className = 'corte-order__cart-line';
        const title = document.createElement('p');
        title.textContent = item.product_title;
        const quantity = document.createElement('p');
        quantity.textContent = item.quantity + ' ' + (row ? this.boxLabel(item.quantity) + ' · ' + item.quantity * Number(row.dataset.rolls) + ' ' + this.labels.rolls : this.labels.quantity) + ' · ' + this.money(item.final_line_price);
        line.append(title, quantity);
        if (row) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.labels.remove;
          remove.setAttribute('aria-label', this.labels.remove + ': ' + item.product_title);
          line.append(remove);
        }
        container.append(line);
      });
      this.querySelector('[data-cart-panel]').hidden = this.cart.items.length === 0;
      this.querySelector('[data-cart-total]').textContent = this.money(this.cart.total_price);
    }
    async onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const row = button.closest('[data-box-product]');
      if (row && (button.hasAttribute('data-preset') || button.hasAttribute('data-step'))) {
        const value = button.hasAttribute('data-preset') ? Number(button.dataset.preset) : this.quantity(row) + Number(button.dataset.step);
        row.querySelector('[data-quantity]').value = Math.min(999, Math.max(0, value));
        this.status('');
        this.render();
      } else if (button.hasAttribute('data-add')) {
        const items = this.rows.filter(row => this.quantity(row) > 0).map(row => ({id: Number(row.dataset.variant), quantity: this.quantity(row)}));
        if (!items.length || button.disabled) return;
        await this.mutateCart('add', {items});
      } else if (button.hasAttribute('data-remove-key')) {
        await this.mutateCart('change', {id: button.dataset.removeKey, quantity: 0});
      }
    }
    async mutateCart(action, payload) {
      this.busy = true;
      this.status(action === 'add' ? this.labels.adding : this.labels.updating);
      this.render();
      this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.root + 'cart/' + action + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(Object.assign({}, payload, {sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname}))
        });
        const data = await response.json();
        if (action === 'add') this.rows.forEach(row => { row.querySelector('[data-quantity]').value = 0; });
        if (!response.ok) {
          await this.refreshCart();
          throw new Error(data.description || data.message || this.labels.error);
        }
        await this.refreshCart();
        this.updateThemeCart(data.sections);
        this.status(action === 'add' ? this.labels.added : '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'blitz-corte-order', cartData: this.cart});
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      } catch (error) {
        this.status(error.message === 'cart' ? this.labels.error : error.message);
      } finally {
        this.busy = false;
        this.render();
        this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = false; });
      }
    }
    updateThemeCart(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const destination = document.getElementById('CartDrawer');
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.toggle('is-empty', this.cart.items.length === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blitz-disp-order"]) return;
  try {
    
if (!customElements.get('blitz-disp-order')) {
  customElements.define('blitz-disp-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.rows = Array.from(this.querySelectorAll('[data-box-product]'));
      this.byVariant = new Map(this.rows.map(row => [Number(row.dataset.variant), row]));
      this.cart = {items: [], total_price: 0, currency: this.dataset.currency || 'MXN'};
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.busy = false;
      this.ready = false;
      this.money = value => new Intl.NumberFormat((document.documentElement.lang || 'es-MX').toLowerCase().startsWith('es') ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.cart.currency || 'MXN'}).format(value / 100);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity]')) {
          event.target.value = Math.min(999, Math.max(0, Math.floor(Number(event.target.value) || 0)));
          this.render();
        }
      });
      this.render();
      this.refreshCart().catch(() => this.status(this.labels.error));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'blitz-disp-order') this.refreshCart().catch(() => this.status(this.labels.error));
        });
      }
      this.pageShow = () => this.refreshCart().catch(() => this.status(this.labels.error));
      window.addEventListener('pageshow', this.pageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShow);
    }
    status(message) { this.querySelector('[data-status]').textContent = message; }
    boxLabel(count) { return count === 1 ? this.labels.box : this.labels.boxes; }
    countLabel(label, count) { return label.replace('[count]', String(count)).replace('[boxes]', this.boxLabel(count)); }
    quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
    existing(row) {
      return this.cart.items.filter(item => Number(item.variant_id) === Number(row.dataset.variant)).reduce((sum, item) => sum + item.quantity, 0);
    }
    async refreshCart() {
      const response = await fetch(this.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cart = await response.json();
      this.ready = true;
      this.renderCart();
      this.render();
    }
    render() {
      let boxes = 0, rolls = 0, subtotal = 0, selected = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        boxes += total;
        selected += qty;
        rolls += total * Number(row.dataset.rolls);
        subtotal += total * Number(row.dataset.price);
        if (qty > 0 && total > Number(row.dataset.stock)) invalid = true;
      });
      const percent = boxes >= 10 ? 10 : boxes >= 5 ? 5 : 0;
      let savings = 0;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        const rowAmount = total * Number(row.dataset.price);
        savings += Math.round(rowAmount * percent / 100);
        const amount = qty * Number(row.dataset.price);
        const payable = amount - Math.round(amount * percent / 100);
        const casePrice = Number(row.dataset.price);
        const discountedCase = casePrice - Math.round(casePrice * percent / 100);
        row.classList.toggle('is-selected', qty > 0 || existing > 0);
        row.querySelector('[data-unit-price]').textContent = this.money(discountedCase / Number(row.dataset.rolls));
        row.querySelector('[data-box-price]').textContent = this.money(discountedCase);
        row.querySelector('[data-unit-regular]').textContent = this.money(casePrice / Number(row.dataset.rolls));
        row.querySelector('[data-unit-regular]').hidden = percent === 0;
        row.querySelector('[data-unit-discount]').textContent = '−' + percent + '%';
        row.querySelector('[data-unit-discount]').hidden = percent === 0;
        row.querySelector('[data-line-total]').hidden = qty === 0;
        row.querySelector('[data-line-count]').textContent = qty + ' ' + this.boxLabel(qty);
        row.querySelector('[data-line-price]').textContent = this.money(payable);
        const selectedPreset = total > 0 ? (boxes >= 10 ? 10 : boxes >= 5 ? 5 : 1) : 0;
        row.querySelectorAll('[data-preset]').forEach(button => {
          const preset = Number(button.dataset.preset);
          button.setAttribute('aria-pressed', String(selectedPreset === preset));
        });
        const stock = Number(row.dataset.stock);
        const stockMessage = row.querySelector('[data-stock-message]');
        const exceeded = qty > 0 && total > stock;
        stockMessage.classList.toggle('is-error', exceeded);
        stockMessage.textContent = (stock === 0 ? this.labels.outOfStock : exceeded ? this.countLabel(this.labels.available, Math.max(0, stock - existing)) : '') + (existing ? ' ' + this.countLabel(this.labels.inCart, existing) : '');
        stockMessage.hidden = !stockMessage.textContent.trim();
      });
      this.querySelector('[data-selection-count]').textContent = boxes + ' ' + this.boxLabel(boxes);
      this.querySelector('[data-discount-current]').textContent = percent + '%';
      this.querySelector('[data-mobile-discount]').textContent = boxes + ' ' + this.boxLabel(boxes) + (percent ? ' · −' + percent + '%' : '');
      const progress = this.querySelector('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(boxes, 10)));
      progress.setAttribute('aria-valuetext', this.countLabel(this.labels.progressText, boxes).replace('[percent]', String(percent)));
      this.querySelector('[data-progress-fill]').style.width = Math.min(boxes, 10) * 10 + '%';
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const current = Number(tier.dataset.tier) === percent;
        tier.classList.toggle('is-current', current);
        if (current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      this.querySelector('[data-savings-row]').hidden = percent === 0;

      this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
      this.querySelector('[data-discount-label]').textContent = this.labels.savings + ' (' + percent + '%)';
      this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
      this.querySelector('[data-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-mobile-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-next-tier]').textContent = boxes >= 10 ? this.labels.bestTier : boxes >= 5 ? this.countLabel(this.labels.moreForTen, 10 - boxes) : this.countLabel(this.labels.moreForFive, 5 - boxes);
      this.querySelector('[data-add]').disabled = this.busy || !this.ready || selected === 0 || invalid;
      this.querySelector('[data-checkout]').disabled = this.busy || this.cart.items.length === 0 || selected > 0;
      this.querySelector('[data-pending-note]').hidden = selected === 0;
      this.querySelectorAll('[data-quantity], [data-preset], [data-step]').forEach(control => { control.disabled = this.busy; });
      if (!this.busy && invalid) this.status(this.labels.stockError);
      else if (!this.busy && this.querySelector('[data-status]').textContent === this.labels.stockError) this.status('');
    }
    renderCart() {
      const container = this.querySelector('[data-cart-lines]');
      container.replaceChildren();
      this.cart.items.forEach(item => {
        const row = this.byVariant.get(Number(item.variant_id));
        const line = document.createElement('div');
        line.className = 'disp-order__cart-line';
        const title = document.createElement('p');
        title.textContent = row ? row.dataset.title : item.product_title;
        const quantity = document.createElement('p');
        quantity.textContent = item.quantity + ' ' + (row ? this.boxLabel(item.quantity) : this.labels.quantity) + ' · ' + this.money(item.final_line_price);
        line.append(title, quantity);
        if (row) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.labels.remove;
          remove.setAttribute('aria-label', this.labels.remove + ': ' + (row ? row.dataset.title : item.product_title));
          line.append(remove);
        }
        container.append(line);
      });
      this.querySelector('[data-cart-panel]').hidden = this.cart.items.length === 0;
      this.querySelector('[data-cart-total]').textContent = this.money(this.cart.total_price);
    }
    async onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const row = button.closest('[data-box-product]');
      if (row && (button.hasAttribute('data-preset') || button.hasAttribute('data-step'))) {
        const value = button.hasAttribute('data-preset') ? Number(button.dataset.preset) : this.quantity(row) + Number(button.dataset.step);
        row.querySelector('[data-quantity]').value = Math.min(999, Math.max(0, value));
        this.status('');
        this.render();
      } else if (button.hasAttribute('data-add')) {
        const items = this.rows.filter(row => this.quantity(row) > 0).map(row => ({id: Number(row.dataset.variant), quantity: this.quantity(row)}));
        if (!items.length || button.disabled) return;
        await this.mutateCart('add', {items});
      } else if (button.hasAttribute('data-remove-key')) {
        await this.mutateCart('change', {id: button.dataset.removeKey, quantity: 0});
      }
    }
    async mutateCart(action, payload) {
      this.busy = true;
      this.status(action === 'add' ? this.labels.adding : this.labels.updating);
      this.render();
      this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.root + 'cart/' + action + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(Object.assign({}, payload, {sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname}))
        });
        const data = await response.json();
        if (action === 'add') this.rows.forEach(row => { row.querySelector('[data-quantity]').value = 0; });
        if (!response.ok) {
          await this.refreshCart();
          throw new Error(data.description || data.message || this.labels.error);
        }
        await this.refreshCart();
        this.updateThemeCart(data.sections);
        this.status(action === 'add' ? this.labels.added : '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'blitz-disp-order', cartData: this.cart});
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      } catch (error) {
        this.status(error.message === 'cart' ? this.labels.error : error.message);
      } finally {
        this.busy = false;
        this.render();
        this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = false; });
      }
    }
    updateThemeCart(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const destination = document.getElementById('CartDrawer');
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.toggle('is-empty', this.cart.items.length === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blitz-ducto-order"]) return;
  try {
    
if (!customElements.get('blitz-ducto-order')) {
  customElements.define('blitz-ducto-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.rows = Array.from(this.querySelectorAll('[data-box-product]'));
      this.byVariant = new Map(this.rows.map(row => [Number(row.dataset.variant), row]));
      this.cart = {items: [], total_price: 0, currency: this.dataset.currency || 'MXN'};
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.busy = false;
      this.ready = false;
      this.money = value => new Intl.NumberFormat((document.documentElement.lang || 'es-MX').toLowerCase().startsWith('es') ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.cart.currency || 'MXN'}).format(value / 100);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity]')) {
          event.target.value = Math.min(999, Math.max(0, Math.floor(Number(event.target.value) || 0)));
          this.render();
        }
      });
      this.render();
      this.refreshCart().catch(() => this.status(this.labels.error));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'blitz-ducto-order') this.refreshCart().catch(() => this.status(this.labels.error));
        });
      }
      this.pageShow = () => this.refreshCart().catch(() => this.status(this.labels.error));
      window.addEventListener('pageshow', this.pageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShow);
    }
    status(message) { this.querySelector('[data-status]').textContent = message; }
    boxLabel(count) { return count === 1 ? this.labels.box : this.labels.boxes; }
    countLabel(label, count) { return label.replace('[count]', String(count)).replace('[boxes]', this.boxLabel(count)); }
    quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
    existing(row) {
      return this.cart.items.filter(item => Number(item.variant_id) === Number(row.dataset.variant)).reduce((sum, item) => sum + item.quantity, 0);
    }
    async refreshCart() {
      const response = await fetch(this.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cart = await response.json();
      this.ready = true;
      this.renderCart();
      this.render();
      try {
        const sectionsResponse = await fetch(this.root + '?sections=cart-icon-bubble', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
        if (sectionsResponse.ok) this.updateThemeCart(await sectionsResponse.json());
      } catch (error) {}
    }
    render() {
      let boxes = 0, rolls = 0, subtotal = 0, selected = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        boxes += total;
        selected += qty;
        rolls += total * Number(row.dataset.rolls);
        subtotal += total * Number(row.dataset.price);
        if (qty > 0 && total > Number(row.dataset.stock)) invalid = true;
      });
      const percent = boxes >= 10 ? 10 : boxes >= 5 ? 5 : 0;
      let savings = 0;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        const rowAmount = total * Number(row.dataset.price);
        savings += Math.round(rowAmount * percent / 100);
        const amount = qty * Number(row.dataset.price);
        const payable = amount - Math.round(amount * percent / 100);
        const casePrice = Number(row.dataset.price);
        const discountedCase = casePrice - Math.round(casePrice * percent / 100);
        row.classList.toggle('is-selected', qty > 0 || existing > 0);
        row.querySelector('[data-unit-price]').textContent = this.money(discountedCase / Number(row.dataset.rolls));
        row.querySelector('[data-box-price]').textContent = this.money(discountedCase);
        row.querySelector('[data-unit-regular]').textContent = this.money(casePrice / Number(row.dataset.rolls));
        row.querySelector('[data-unit-regular]').hidden = percent === 0;
        row.querySelector('[data-unit-discount]').textContent = '−' + percent + '%';
        row.querySelector('[data-unit-discount]').hidden = percent === 0;
        row.querySelector('[data-line-total]').hidden = qty === 0;
        row.querySelector('[data-line-count]').textContent = qty + ' ' + this.boxLabel(qty) + ' · ' + (qty * Number(row.dataset.rolls)).toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
        row.querySelector('[data-line-price]').textContent = this.money(payable);
        const selectedPreset = total >= 10 ? 10 : total >= 5 ? 5 : total > 0 ? 1 : 0;
        row.querySelectorAll('[data-preset]').forEach(button => {
          const preset = Number(button.dataset.preset);
          const candidateBoxes = boxes - qty + preset;
          const candidatePercent = candidateBoxes >= 10 ? 10 : candidateBoxes >= 5 ? 5 : 0;
          button.setAttribute('aria-pressed', String(selectedPreset === preset));
          const discountLabel = button.querySelector('[data-preset-discount]');
          discountLabel.textContent = candidatePercent ? '−' + candidatePercent + '%' : '';
          discountLabel.hidden = candidatePercent === 0;
          button.setAttribute('aria-label', candidatePercent ? this.countLabel(this.labels.progressText, preset).replace('[percent]', String(candidatePercent)) : preset + ' ' + this.boxLabel(preset));
        });
        const stock = Number(row.dataset.stock);
        const stockMessage = row.querySelector('[data-stock-message]');
        const exceeded = qty > 0 && total > stock;
        stockMessage.classList.toggle('is-error', exceeded);
        stockMessage.textContent = (stock === 0 ? this.labels.outOfStock : exceeded ? this.countLabel(this.labels.available, Math.max(0, stock - existing)) : '') + (existing ? ' ' + this.countLabel(this.labels.inCart, existing) : '');
        stockMessage.hidden = !stockMessage.textContent.trim();
      });
      this.querySelector('[data-selection-count]').textContent = boxes + ' ' + this.boxLabel(boxes) + ' · ' + rolls.toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
      this.querySelector('[data-discount-current]').textContent = percent + '%';
      this.querySelector('[data-mobile-discount]').textContent = boxes + ' ' + this.boxLabel(boxes) + (percent ? ' · −' + percent + '%' : '');
      const progress = this.querySelector('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(boxes, 10)));
      progress.setAttribute('aria-valuetext', this.countLabel(this.labels.progressText, boxes).replace('[percent]', String(percent)));
      this.querySelector('[data-progress-fill]').style.width = Math.min(boxes, 10) * 10 + '%';
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const current = Number(tier.dataset.tier) === percent;
        tier.classList.toggle('is-current', current);
        if (current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      this.querySelector('[data-savings-row]').hidden = percent === 0;

      this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
      this.querySelector('[data-discount-label]').textContent = this.labels.savings + ' (' + percent + '%)';
      this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
      this.querySelector('[data-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-mobile-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-next-tier]').textContent = boxes >= 10 ? this.labels.bestTier : boxes >= 5 ? this.countLabel(this.labels.moreForTen, 10 - boxes) : this.countLabel(this.labels.moreForFive, 5 - boxes);
      this.querySelector('[data-add]').disabled = this.busy || !this.ready || selected === 0 || invalid;
      this.querySelector('[data-checkout]').disabled = this.busy || this.cart.items.length === 0 || selected > 0;
      this.querySelector('[data-pending-note]').hidden = selected === 0;
      this.querySelectorAll('[data-quantity], [data-preset], [data-step]').forEach(control => { control.disabled = this.busy; });
      if (!this.busy && invalid) this.status(this.labels.stockError);
      else if (!this.busy && this.querySelector('[data-status]').textContent === this.labels.stockError) this.status('');
    }
    renderCart() {
      const container = this.querySelector('[data-cart-lines]');
      container.replaceChildren();
      this.cart.items.forEach(item => {
        const row = this.byVariant.get(Number(item.variant_id));
        const line = document.createElement('div');
        line.className = 'ducto-order__cart-line';
        const title = document.createElement('p');
        title.textContent = item.product_title;
        const quantity = document.createElement('p');
        quantity.textContent = item.quantity + ' ' + (row ? this.boxLabel(item.quantity) + ' · ' + item.quantity * Number(row.dataset.rolls) + ' ' + this.labels.rolls : this.labels.quantity) + ' · ' + this.money(item.final_line_price);
        line.append(title, quantity);
        if (row) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.labels.remove;
          remove.setAttribute('aria-label', this.labels.remove + ': ' + item.product_title);
          line.append(remove);
        }
        container.append(line);
      });
      this.querySelector('[data-cart-panel]').hidden = this.cart.items.length === 0;
      this.querySelector('[data-cart-total]').textContent = this.money(this.cart.total_price);
    }
    async onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const row = button.closest('[data-box-product]');
      if (row && (button.hasAttribute('data-preset') || button.hasAttribute('data-step'))) {
        const value = button.hasAttribute('data-preset') ? Number(button.dataset.preset) : this.quantity(row) + Number(button.dataset.step);
        row.querySelector('[data-quantity]').value = Math.min(999, Math.max(0, value));
        this.status('');
        this.render();
      } else if (row && button.hasAttribute('data-gallery-shortcut')) {
        row.querySelector('[data-gallery-open]').click();
      } else if (button.hasAttribute('data-add')) {
        const items = this.rows.filter(row => this.quantity(row) > 0).map(row => ({id: Number(row.dataset.variant), quantity: this.quantity(row)}));
        if (!items.length || button.disabled) return;
        await this.mutateCart('add', {items});
      } else if (button.hasAttribute('data-remove-key')) {
        await this.mutateCart('change', {id: button.dataset.removeKey, quantity: 0});
      }
    }
    async mutateCart(action, payload) {
      this.busy = true;
      this.status(action === 'add' ? this.labels.adding : this.labels.updating);
      this.render();
      this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.root + 'cart/' + action + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(Object.assign({}, payload, {sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname}))
        });
        const data = await response.json();
        if (action === 'add') this.rows.forEach(row => { row.querySelector('[data-quantity]').value = 0; });
        if (!response.ok) {
          await this.refreshCart();
          throw new Error(data.description || data.message || this.labels.error);
        }
        await this.refreshCart();
        this.updateThemeCart(data.sections);
        this.status(action === 'add' ? this.labels.added : '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'blitz-ducto-order', cartData: this.cart});
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      } catch (error) {
        this.status(error.message === 'cart' ? this.labels.error : error.message);
      } finally {
        this.busy = false;
        this.render();
        this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = false; });
      }
    }
    updateThemeCart(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const destination = document.getElementById('CartDrawer');
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.toggle('is-empty', this.cart.items.length === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blitz-filament-order"]) return;
  try {
    
if (!customElements.get('blitz-filament-order')) {
  customElements.define('blitz-filament-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.rows = Array.from(this.querySelectorAll('[data-box-product]'));
      this.byVariant = new Map(this.rows.map(row => [Number(row.dataset.variant), row]));
      this.cart = {items: [], total_price: 0, currency: this.dataset.currency || 'MXN'};
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.busy = false;
      this.ready = false;
      this.money = value => new Intl.NumberFormat((document.documentElement.lang || 'es-MX').toLowerCase().startsWith('es') ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.cart.currency || 'MXN'}).format(value / 100);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity]')) {
          event.target.value = Math.min(999, Math.max(0, Math.floor(Number(event.target.value) || 0)));
          this.render();
        }
      });
      const requestedWidth = new URL(window.location.href).searchParams.get('ancho');
      const requestedRow = this.rows.find(row => row.dataset.width === requestedWidth);
      if (requestedRow) requestedRow.querySelector('[data-quantity]').value = 1;
      this.render();
      this.refreshCart().catch(() => this.status(this.labels.error));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'blitz-filament-order') this.refreshCart().catch(() => this.status(this.labels.error));
        });
      }
      this.pageShow = () => this.refreshCart().catch(() => this.status(this.labels.error));
      window.addEventListener('pageshow', this.pageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShow);
    }
    status(message) { this.querySelector('[data-status]').textContent = message; }
    boxLabel(count) { return count === 1 ? this.labels.box : this.labels.boxes; }
    countLabel(label, count) { return label.replace('[count]', String(count)).replace('[boxes]', this.boxLabel(count)); }
    quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
    existing(row) {
      return this.cart.items.filter(item => Number(item.variant_id) === Number(row.dataset.variant)).reduce((sum, item) => sum + item.quantity, 0);
    }
    async refreshCart() {
      const response = await fetch(this.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cart = await response.json();
      this.ready = true;
      this.renderCart();
      this.render();
      try {
        const sectionsResponse = await fetch(this.root + '?sections=cart-icon-bubble', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
        if (sectionsResponse.ok) this.updateThemeCart(await sectionsResponse.json());
      } catch (error) {}
    }
    render() {
      let boxes = 0, rolls = 0, subtotal = 0, selected = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        boxes += total;
        selected += qty;
        rolls += total * Number(row.dataset.rolls);
        subtotal += total * Number(row.dataset.price);
        if (qty > 0 && total > Number(row.dataset.stock)) invalid = true;
      });
      const percent = boxes >= 10 ? 10 : boxes >= 5 ? 5 : 0;
      let savings = 0;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        const rowAmount = total * Number(row.dataset.price);
        savings += Math.round(rowAmount * percent / 100);
        const amount = qty * Number(row.dataset.price);
        const payable = amount - Math.round(amount * percent / 100);
        const casePrice = Number(row.dataset.price);
        const discountedCase = casePrice - Math.round(casePrice * percent / 100);
        row.classList.toggle('is-selected', qty > 0 || existing > 0);
        row.querySelector('[data-unit-price]').textContent = this.money(discountedCase / Number(row.dataset.rolls));
        row.querySelector('[data-box-price]').textContent = this.money(discountedCase);
        row.querySelector('[data-unit-regular]').textContent = this.money(casePrice / Number(row.dataset.rolls));
        row.querySelector('[data-unit-regular]').hidden = percent === 0;
        row.querySelector('[data-unit-discount]').textContent = '−' + percent + '%';
        row.querySelector('[data-unit-discount]').hidden = percent === 0;
        row.querySelector('[data-line-total]').hidden = qty === 0;
        row.querySelector('[data-line-count]').textContent = qty + ' ' + this.boxLabel(qty) + ' · ' + (qty * Number(row.dataset.rolls)).toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
        row.querySelector('[data-line-price]').textContent = this.money(payable);
        const selectedPreset = total >= 10 ? 10 : total >= 5 ? 5 : total > 0 ? 1 : 0;
        row.querySelectorAll('[data-preset]').forEach(button => {
          const preset = Number(button.dataset.preset);
          const candidateBoxes = boxes - qty + preset;
          const candidatePercent = candidateBoxes >= 10 ? 10 : candidateBoxes >= 5 ? 5 : 0;
          button.setAttribute('aria-pressed', String(selectedPreset === preset));
          const discountLabel = button.querySelector('[data-preset-discount]');
          discountLabel.textContent = candidatePercent ? '−' + candidatePercent + '%' : '';
          discountLabel.hidden = candidatePercent === 0;
          button.setAttribute('aria-label', candidatePercent ? this.countLabel(this.labels.progressText, preset).replace('[percent]', String(candidatePercent)) : preset + ' ' + this.boxLabel(preset));
        });
        const stock = Number(row.dataset.stock);
        const stockMessage = row.querySelector('[data-stock-message]');
        const exceeded = qty > 0 && total > stock;
        stockMessage.classList.toggle('is-error', exceeded);
        stockMessage.textContent = (stock === 0 ? this.labels.outOfStock : exceeded ? this.countLabel(this.labels.available, Math.max(0, stock - existing)) : '') + (existing ? ' ' + this.countLabel(this.labels.inCart, existing) : '');
        stockMessage.hidden = !stockMessage.textContent.trim();
      });
      this.querySelector('[data-selection-count]').textContent = boxes + ' ' + this.boxLabel(boxes) + ' · ' + rolls.toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
      this.querySelector('[data-discount-current]').textContent = percent + '%';
      this.querySelector('[data-mobile-discount]').textContent = boxes + ' ' + this.boxLabel(boxes) + (percent ? ' · −' + percent + '%' : '');
      const progress = this.querySelector('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(boxes, 10)));
      progress.setAttribute('aria-valuetext', this.countLabel(this.labels.progressText, boxes).replace('[percent]', String(percent)));
      this.querySelector('[data-progress-fill]').style.width = Math.min(boxes, 10) * 10 + '%';
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const current = Number(tier.dataset.tier) === percent;
        tier.classList.toggle('is-current', current);
        if (current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      this.querySelector('[data-savings-row]').hidden = percent === 0;

      this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
      this.querySelector('[data-discount-label]').textContent = this.labels.savings + ' (' + percent + '%)';
      this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
      this.querySelector('[data-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-mobile-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-next-tier]').textContent = boxes >= 10 ? this.labels.bestTier : boxes >= 5 ? this.countLabel(this.labels.moreForTen, 10 - boxes) : this.countLabel(this.labels.moreForFive, 5 - boxes);
      this.querySelector('[data-add]').disabled = this.busy || !this.ready || selected === 0 || invalid;
      this.querySelector('[data-checkout]').disabled = this.busy || this.cart.items.length === 0 || selected > 0;
      this.querySelector('[data-pending-note]').hidden = selected === 0;
      this.querySelectorAll('[data-quantity], [data-preset], [data-step]').forEach(control => { control.disabled = this.busy; });
      if (!this.busy && invalid) this.status(this.labels.stockError);
      else if (!this.busy && this.querySelector('[data-status]').textContent === this.labels.stockError) this.status('');
    }
    renderCart() {
      const container = this.querySelector('[data-cart-lines]');
      container.replaceChildren();
      this.cart.items.forEach(item => {
        const row = this.byVariant.get(Number(item.variant_id));
        const line = document.createElement('div');
        line.className = 'filament-order__cart-line';
        const title = document.createElement('p');
        title.textContent = item.product_title;
        const quantity = document.createElement('p');
        quantity.textContent = item.quantity + ' ' + (row ? this.boxLabel(item.quantity) + ' · ' + item.quantity * Number(row.dataset.rolls) + ' ' + this.labels.rolls : this.labels.quantity) + ' · ' + this.money(item.final_line_price);
        line.append(title, quantity);
        if (row) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.labels.remove;
          remove.setAttribute('aria-label', this.labels.remove + ': ' + item.product_title);
          line.append(remove);
        }
        container.append(line);
      });
      this.querySelector('[data-cart-panel]').hidden = this.cart.items.length === 0;
      this.querySelector('[data-cart-total]').textContent = this.money(this.cart.total_price);
    }
    async onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const row = button.closest('[data-box-product]');
      if (row && (button.hasAttribute('data-preset') || button.hasAttribute('data-step'))) {
        const value = button.hasAttribute('data-preset') ? Number(button.dataset.preset) : this.quantity(row) + Number(button.dataset.step);
        row.querySelector('[data-quantity]').value = Math.min(999, Math.max(0, value));
        this.status('');
        this.render();
      } else if (button.hasAttribute('data-add')) {
        const items = this.rows.filter(row => this.quantity(row) > 0).map(row => ({id: Number(row.dataset.variant), quantity: this.quantity(row)}));
        if (!items.length || button.disabled) return;
        await this.mutateCart('add', {items});
      } else if (button.hasAttribute('data-remove-key')) {
        await this.mutateCart('change', {id: button.dataset.removeKey, quantity: 0});
      }
    }
    async mutateCart(action, payload) {
      this.busy = true;
      this.status(action === 'add' ? this.labels.adding : this.labels.updating);
      this.render();
      this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.root + 'cart/' + action + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(Object.assign({}, payload, {sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname}))
        });
        const data = await response.json();
        if (action === 'add') this.rows.forEach(row => { row.querySelector('[data-quantity]').value = 0; });
        if (!response.ok) {
          await this.refreshCart();
          throw new Error(data.description || data.message || this.labels.error);
        }
        await this.refreshCart();
        this.updateThemeCart(data.sections);
        this.status(action === 'add' ? this.labels.added : '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'blitz-filament-order', cartData: this.cart});
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      } catch (error) {
        this.status(error.message === 'cart' ? this.labels.error : error.message);
      } finally {
        this.busy = false;
        this.render();
        this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = false; });
      }
    }
    updateThemeCart(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const destination = document.getElementById('CartDrawer');
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.toggle('is-empty', this.cart.items.length === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blitz-kit-order"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('blitz-kit-order')){
customElements.define('blitz-kit-order',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.variants=JSON.parse(this.querySelector('[data-kit-variants]').textContent);this.labels=JSON.parse(this.querySelector('[data-kit-labels]').textContent);
this.form=this.querySelector('form');this.quantity=this.querySelector('[data-quantity]');this.variantInput=this.querySelector('[data-variant-input]');this.variantInput.disabled=false;
this.money=new Intl.NumberFormat((document.documentElement.lang||'es').startsWith('es')?'es-MX':'en-US',{style:'currency',currency:this.dataset.currency||'MXN',minimumFractionDigits:2,maximumFractionDigits:2});
this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.dataset.step){this.quantity.value=String(Math.min(999,Math.max(1,(Number(this.quantity.value)||1)+Number(b.dataset.step))));this.update()}if(b.dataset.preset){this.quantity.value=b.dataset.preset;this.update()}});
this.addEventListener('change',()=>this.update());this.quantity.addEventListener('input',()=>this.update());
this.form.addEventListener('submit',e=>this.add(e));this.update();
}
format(cents){return this.money.format(cents/100)}
update(){
const color=this.querySelector('[name=kit_color]:checked')?.value;const material=this.querySelector('[name=kit_material]:checked')?.value;
this.variant=this.variants.find(v=>v.color===color&&v.material===material);
const q=Number(this.quantity.value);const valid=Number.isInteger(q)&&q>=1&&q<=999;this.quantity.setCustomValidity(valid?'':this.labels.integer);
const v=this.variant;if(!v)return;this.variantInput.value=String(v.id);
this.querySelector('[data-unit]').textContent=this.format(v.price);this.querySelector('[data-unit-before]').textContent=this.format(v.before);
this.querySelector('[data-total]').textContent=valid?this.format(v.price*q):'—';this.querySelector('[data-savings]').textContent=valid?this.format((v.before-v.price)*q):'—';
this.querySelector('[data-contents]').textContent=valid?q+' '+(q===1?this.labels.kit:this.labels.kits)+' · '+q*36+' '+this.labels.rolls+' · '+q+' '+(q===1?this.labels.dispenser:this.labels.dispensers):this.labels.integer;
this.querySelectorAll('[data-preset]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.preset)===q)));
const tape=this.querySelector('[data-tape-photo]');tape.src=color==='Canela'?this.labels.brownPhoto:this.labels.clearPhoto;tape.alt=color==='Canela'?this.labels.brownAlt:this.labels.clearAlt;
const disp=this.querySelector('[data-dispenser-photo]');disp.src=material==='Metal'?this.labels.metalPhoto:this.labels.plasticPhoto;disp.alt=material==='Metal'?this.labels.metalAlt:this.labels.plasticAlt;
const button=this.querySelector('[data-add]');button.disabled=this.busy||!v.available||!valid;button.textContent=this.busy?this.labels.adding:v.available?this.labels.add:this.labels.unavailable;
}
async add(event){
event.preventDefault();if(this.busy||!this.form.reportValidity()||!this.variant?.available)return;
this.busy=true;this.update();const status=this.querySelector('[data-status]');status.textContent='';
try{
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:Number(this.quantity.value)}],sections:['cart-icon-bubble'],sections_url:window.location.pathname})});
const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.labels.error);
status.textContent=this.labels.added;this.querySelector('[data-cart-link]').hidden=false;
const bubble=document.getElementById('cart-icon-bubble');const html=result.sections?.['cart-icon-bubble'];if(bubble&&html){const parsed=new DOMParser().parseFromString(html,'text/html');const fresh=parsed.querySelector('.shopify-section');if(fresh)bubble.innerHTML=fresh.innerHTML;}
if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'blitz-kit-order'});
}catch(error){status.textContent=error.message||this.labels.error}
finally{this.busy=false;this.update()}
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blitz-marcaje-order"]) return;
  try {
    
if (!customElements.get('blitz-marcaje-order')) {
  customElements.define('blitz-marcaje-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.rows = Array.from(this.querySelectorAll('[data-box-product]'));
      this.byVariant = new Map(this.rows.map(row => [Number(row.dataset.variant), row]));
      this.cart = {items: [], total_price: 0, currency: this.dataset.currency || 'MXN'};
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.busy = false;
      this.ready = false;
      this.money = value => new Intl.NumberFormat((document.documentElement.lang || 'es-MX').toLowerCase().startsWith('es') ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.cart.currency || 'MXN'}).format(value / 100);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity]')) {
          event.target.value = Math.min(999, Math.max(0, Math.floor(Number(event.target.value) || 0)));
          this.render();
        }
      });
      this.render();
      this.refreshCart().catch(() => this.status(this.labels.error));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'blitz-marcaje-order') this.refreshCart().catch(() => this.status(this.labels.error));
        });
      }
      this.pageShow = () => this.refreshCart().catch(() => this.status(this.labels.error));
      window.addEventListener('pageshow', this.pageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShow);
    }
    status(message) { this.querySelector('[data-status]').textContent = message; }
    boxLabel(count) { return count === 1 ? this.labels.box : this.labels.boxes; }
    countLabel(label, count) { return label.replace('[count]', String(count)).replace('[boxes]', this.boxLabel(count)); }
    quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
    existing(row) {
      return this.cart.items.filter(item => Number(item.variant_id) === Number(row.dataset.variant)).reduce((sum, item) => sum + item.quantity, 0);
    }
    async refreshCart() {
      const response = await fetch(this.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cart = await response.json();
      this.ready = true;
      this.renderCart();
      this.render();
      try {
        const sectionsResponse = await fetch(this.root + '?sections=cart-icon-bubble', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
        if (sectionsResponse.ok) this.updateThemeCart(await sectionsResponse.json());
      } catch (error) {}
    }
    render() {
      let boxes = 0, rolls = 0, subtotal = 0, selected = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        boxes += total;
        selected += qty;
        rolls += total * Number(row.dataset.rolls);
        subtotal += total * Number(row.dataset.price);
        if (qty > 0 && total > Number(row.dataset.stock)) invalid = true;
      });
      const percent = boxes >= 10 ? 10 : boxes >= 5 ? 5 : 0;
      let savings = 0;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        const rowAmount = total * Number(row.dataset.price);
        savings += Math.round(rowAmount * percent / 100);
        const amount = qty * Number(row.dataset.price);
        const payable = amount - Math.round(amount * percent / 100);
        const casePrice = Number(row.dataset.price);
        const discountedCase = casePrice - Math.round(casePrice * percent / 100);
        row.classList.toggle('is-selected', qty > 0 || existing > 0);
        row.querySelector('[data-unit-price]').textContent = this.money(discountedCase / Number(row.dataset.rolls));
        row.querySelector('[data-box-price]').textContent = this.money(discountedCase);
        row.querySelector('[data-unit-regular]').textContent = this.money(casePrice / Number(row.dataset.rolls));
        row.querySelector('[data-unit-regular]').hidden = percent === 0;
        row.querySelector('[data-unit-discount]').textContent = '−' + percent + '%';
        row.querySelector('[data-unit-discount]').hidden = percent === 0;
        row.querySelector('[data-line-total]').hidden = qty === 0;
        row.querySelector('[data-line-count]').textContent = qty + ' ' + this.boxLabel(qty) + ' · ' + (qty * Number(row.dataset.rolls)).toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
        row.querySelector('[data-line-price]').textContent = this.money(payable);
        const selectedPreset = total >= 10 ? 10 : total >= 5 ? 5 : total > 0 ? 1 : 0;
        row.querySelectorAll('[data-preset]').forEach(button => {
          const preset = Number(button.dataset.preset);
          const candidateBoxes = boxes - qty + preset;
          const candidatePercent = candidateBoxes >= 10 ? 10 : candidateBoxes >= 5 ? 5 : 0;
          button.setAttribute('aria-pressed', String(selectedPreset === preset));
          const discountLabel = button.querySelector('[data-preset-discount]');
          discountLabel.textContent = candidatePercent ? '−' + candidatePercent + '%' : '';
          discountLabel.hidden = candidatePercent === 0;
          button.setAttribute('aria-label', candidatePercent ? this.countLabel(this.labels.progressText, preset).replace('[percent]', String(candidatePercent)) : preset + ' ' + this.boxLabel(preset));
        });
        const stock = Number(row.dataset.stock);
        const stockMessage = row.querySelector('[data-stock-message]');
        const exceeded = qty > 0 && total > stock;
        stockMessage.classList.toggle('is-error', exceeded);
        stockMessage.textContent = (stock === 0 ? this.labels.outOfStock : exceeded ? this.countLabel(this.labels.available, Math.max(0, stock - existing)) : '') + (existing ? ' ' + this.countLabel(this.labels.inCart, existing) : '');
        stockMessage.hidden = !stockMessage.textContent.trim();
      });
      this.querySelector('[data-selection-count]').textContent = boxes + ' ' + this.boxLabel(boxes) + ' · ' + rolls.toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
      this.querySelector('[data-discount-current]').textContent = percent + '%';
      this.querySelector('[data-mobile-discount]').textContent = boxes + ' ' + this.boxLabel(boxes) + (percent ? ' · −' + percent + '%' : '');
      const progress = this.querySelector('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(boxes, 10)));
      progress.setAttribute('aria-valuetext', this.countLabel(this.labels.progressText, boxes).replace('[percent]', String(percent)));
      this.querySelector('[data-progress-fill]').style.width = Math.min(boxes, 10) * 10 + '%';
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const current = Number(tier.dataset.tier) === percent;
        tier.classList.toggle('is-current', current);
        if (current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      this.querySelector('[data-savings-row]').hidden = percent === 0;

      this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
      this.querySelector('[data-discount-label]').textContent = this.labels.savings + ' (' + percent + '%)';
      this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
      this.querySelector('[data-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-mobile-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-next-tier]').textContent = boxes >= 10 ? this.labels.bestTier : boxes >= 5 ? this.countLabel(this.labels.moreForTen, 10 - boxes) : this.countLabel(this.labels.moreForFive, 5 - boxes);
      this.querySelector('[data-add]').disabled = this.busy || !this.ready || selected === 0 || invalid;
      this.querySelector('[data-checkout]').disabled = this.busy || this.cart.items.length === 0 || selected > 0;
      this.querySelector('[data-pending-note]').hidden = selected === 0;
      this.querySelectorAll('[data-quantity], [data-preset], [data-step]').forEach(control => { control.disabled = this.busy; });
      if (!this.busy && invalid) this.status(this.labels.stockError);
      else if (!this.busy && this.querySelector('[data-status]').textContent === this.labels.stockError) this.status('');
    }
    renderCart() {
      const container = this.querySelector('[data-cart-lines]');
      container.replaceChildren();
      this.cart.items.forEach(item => {
        const row = this.byVariant.get(Number(item.variant_id));
        const line = document.createElement('div');
        line.className = 'marcaje-order__cart-line';
        const title = document.createElement('p');
        title.textContent = item.product_title;
        const quantity = document.createElement('p');
        quantity.textContent = item.quantity + ' ' + (row ? this.boxLabel(item.quantity) + ' · ' + item.quantity * Number(row.dataset.rolls) + ' ' + this.labels.rolls : this.labels.quantity) + ' · ' + this.money(item.final_line_price);
        line.append(title, quantity);
        if (row) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.labels.remove;
          remove.setAttribute('aria-label', this.labels.remove + ': ' + item.product_title);
          line.append(remove);
        }
        container.append(line);
      });
      this.querySelector('[data-cart-panel]').hidden = this.cart.items.length === 0;
      this.querySelector('[data-cart-total]').textContent = this.money(this.cart.total_price);
    }
    async onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const row = button.closest('[data-box-product]');
      if (row && (button.hasAttribute('data-preset') || button.hasAttribute('data-step'))) {
        const value = button.hasAttribute('data-preset') ? Number(button.dataset.preset) : this.quantity(row) + Number(button.dataset.step);
        row.querySelector('[data-quantity]').value = Math.min(999, Math.max(0, value));
        this.status('');
        this.render();
      } else if (row && button.hasAttribute('data-gallery-shortcut')) {
        row.querySelector('[data-gallery-open]').click();
      } else if (button.hasAttribute('data-add')) {
        const items = this.rows.filter(row => this.quantity(row) > 0).map(row => ({id: Number(row.dataset.variant), quantity: this.quantity(row)}));
        if (!items.length || button.disabled) return;
        await this.mutateCart('add', {items});
      } else if (button.hasAttribute('data-remove-key')) {
        await this.mutateCart('change', {id: button.dataset.removeKey, quantity: 0});
      }
    }
    async mutateCart(action, payload) {
      this.busy = true;
      this.status(action === 'add' ? this.labels.adding : this.labels.updating);
      this.render();
      this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.root + 'cart/' + action + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(Object.assign({}, payload, {sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname}))
        });
        const data = await response.json();
        if (action === 'add') this.rows.forEach(row => { row.querySelector('[data-quantity]').value = 0; });
        if (!response.ok) {
          await this.refreshCart();
          throw new Error(data.description || data.message || this.labels.error);
        }
        await this.refreshCart();
        this.updateThemeCart(data.sections);
        this.status(action === 'add' ? this.labels.added : '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'blitz-marcaje-order', cartData: this.cart});
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      } catch (error) {
        this.status(error.message === 'cart' ? this.labels.error : error.message);
      } finally {
        this.busy = false;
        this.render();
        this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = false; });
      }
    }
    updateThemeCart(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const destination = document.getElementById('CartDrawer');
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.toggle('is-empty', this.cart.items.length === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blitz-masking-order"]) return;
  try {
    
if (!customElements.get('blitz-masking-order')) {
  customElements.define('blitz-masking-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.rows = Array.from(this.querySelectorAll('[data-box-product]'));
      this.byVariant = new Map(this.rows.map(row => [Number(row.dataset.variant), row]));
      this.cart = {items: [], total_price: 0, currency: this.dataset.currency || 'MXN'};
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.busy = false;
      this.ready = false;
      this.money = value => new Intl.NumberFormat((document.documentElement.lang || 'es-MX').toLowerCase().startsWith('es') ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.cart.currency || 'MXN'}).format(value / 100);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity]')) {
          event.target.value = Math.min(999, Math.max(0, Math.floor(Number(event.target.value) || 0)));
          this.render();
        }
      });
      const requestedWidth = new URL(window.location.href).searchParams.get('ancho');
      const requestedRow = this.rows.find(row => row.dataset.width === requestedWidth);
      if (requestedRow) requestedRow.querySelector('[data-quantity]').value = 1;
      this.render();
      this.refreshCart().catch(() => this.status(this.labels.error));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'blitz-masking-order') this.refreshCart().catch(() => this.status(this.labels.error));
        });
      }
      this.pageShow = () => this.refreshCart().catch(() => this.status(this.labels.error));
      window.addEventListener('pageshow', this.pageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShow);
    }
    status(message) { this.querySelector('[data-status]').textContent = message; }
    boxLabel(count) { return count === 1 ? this.labels.box : this.labels.boxes; }
    countLabel(label, count) { return label.replace('[count]', String(count)).replace('[boxes]', this.boxLabel(count)); }
    quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
    existing(row) {
      return this.cart.items.filter(item => Number(item.variant_id) === Number(row.dataset.variant)).reduce((sum, item) => sum + item.quantity, 0);
    }
    async refreshCart() {
      const response = await fetch(this.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cart = await response.json();
      this.ready = true;
      this.renderCart();
      this.render();
      try {
        const sectionsResponse = await fetch(this.root + '?sections=cart-icon-bubble', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
        if (sectionsResponse.ok) this.updateThemeCart(await sectionsResponse.json());
      } catch (error) {}
    }
    render() {
      let boxes = 0, rolls = 0, subtotal = 0, selected = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        boxes += total;
        selected += qty;
        rolls += total * Number(row.dataset.rolls);
        subtotal += total * Number(row.dataset.price);
        if (qty > 0 && total > Number(row.dataset.stock)) invalid = true;
      });
      const percent = boxes >= 10 ? 10 : boxes >= 5 ? 5 : 0;
      let savings = 0;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        const rowAmount = total * Number(row.dataset.price);
        savings += Math.round(rowAmount * percent / 100);
        const amount = qty * Number(row.dataset.price);
        const payable = amount - Math.round(amount * percent / 100);
        const casePrice = Number(row.dataset.price);
        const discountedCase = casePrice - Math.round(casePrice * percent / 100);
        row.classList.toggle('is-selected', qty > 0 || existing > 0);
        row.querySelector('[data-unit-price]').textContent = this.money(discountedCase / Number(row.dataset.rolls));
        row.querySelector('[data-box-price]').textContent = this.money(discountedCase);
        row.querySelector('[data-unit-regular]').textContent = this.money(casePrice / Number(row.dataset.rolls));
        row.querySelector('[data-unit-regular]').hidden = percent === 0;
        row.querySelector('[data-unit-discount]').textContent = '−' + percent + '%';
        row.querySelector('[data-unit-discount]').hidden = percent === 0;
        row.querySelector('[data-line-total]').hidden = qty === 0;
        row.querySelector('[data-line-count]').textContent = qty + ' ' + this.boxLabel(qty) + ' · ' + (qty * Number(row.dataset.rolls)).toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
        row.querySelector('[data-line-price]').textContent = this.money(payable);
        const selectedPreset = total >= 10 ? 10 : total >= 5 ? 5 : total > 0 ? 1 : 0;
        row.querySelectorAll('[data-preset]').forEach(button => {
          const preset = Number(button.dataset.preset);
          const candidateBoxes = boxes - qty + preset;
          const candidatePercent = candidateBoxes >= 10 ? 10 : candidateBoxes >= 5 ? 5 : 0;
          button.setAttribute('aria-pressed', String(selectedPreset === preset));
          const discountLabel = button.querySelector('[data-preset-discount]');
          discountLabel.textContent = candidatePercent ? '−' + candidatePercent + '%' : '';
          discountLabel.hidden = candidatePercent === 0;
          button.setAttribute('aria-label', candidatePercent ? this.countLabel(this.labels.progressText, preset).replace('[percent]', String(candidatePercent)) : preset + ' ' + this.boxLabel(preset));
        });
        const stock = Number(row.dataset.stock);
        const stockMessage = row.querySelector('[data-stock-message]');
        const exceeded = qty > 0 && total > stock;
        stockMessage.classList.toggle('is-error', exceeded);
        stockMessage.textContent = (stock === 0 ? this.labels.outOfStock : exceeded ? this.countLabel(this.labels.available, Math.max(0, stock - existing)) : '') + (existing ? ' ' + this.countLabel(this.labels.inCart, existing) : '');
        stockMessage.hidden = !stockMessage.textContent.trim();
      });
      this.querySelector('[data-selection-count]').textContent = boxes + ' ' + this.boxLabel(boxes) + ' · ' + rolls.toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
      this.querySelector('[data-discount-current]').textContent = percent + '%';
      this.querySelector('[data-mobile-discount]').textContent = boxes + ' ' + this.boxLabel(boxes) + (percent ? ' · −' + percent + '%' : '');
      const progress = this.querySelector('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(boxes, 10)));
      progress.setAttribute('aria-valuetext', this.countLabel(this.labels.progressText, boxes).replace('[percent]', String(percent)));
      this.querySelector('[data-progress-fill]').style.width = Math.min(boxes, 10) * 10 + '%';
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const current = Number(tier.dataset.tier) === percent;
        tier.classList.toggle('is-current', current);
        if (current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      this.querySelector('[data-savings-row]').hidden = percent === 0;

      this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
      this.querySelector('[data-discount-label]').textContent = this.labels.savings + ' (' + percent + '%)';
      this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
      this.querySelector('[data-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-mobile-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-next-tier]').textContent = boxes >= 10 ? this.labels.bestTier : boxes >= 5 ? this.countLabel(this.labels.moreForTen, 10 - boxes) : this.countLabel(this.labels.moreForFive, 5 - boxes);
      this.querySelector('[data-add]').disabled = this.busy || !this.ready || selected === 0 || invalid;
      this.querySelector('[data-checkout]').disabled = this.busy || this.cart.items.length === 0 || selected > 0;
      this.querySelector('[data-pending-note]').hidden = selected === 0;
      this.querySelectorAll('[data-quantity], [data-preset], [data-step]').forEach(control => { control.disabled = this.busy; });
      if (!this.busy && invalid) this.status(this.labels.stockError);
      else if (!this.busy && this.querySelector('[data-status]').textContent === this.labels.stockError) this.status('');
    }
    renderCart() {
      const container = this.querySelector('[data-cart-lines]');
      container.replaceChildren();
      this.cart.items.forEach(item => {
        const row = this.byVariant.get(Number(item.variant_id));
        const line = document.createElement('div');
        line.className = 'masking-order__cart-line';
        const title = document.createElement('p');
        title.textContent = item.product_title;
        const quantity = document.createElement('p');
        quantity.textContent = item.quantity + ' ' + (row ? this.boxLabel(item.quantity) + ' · ' + item.quantity * Number(row.dataset.rolls) + ' ' + this.labels.rolls : this.labels.quantity) + ' · ' + this.money(item.final_line_price);
        line.append(title, quantity);
        if (row) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.labels.remove;
          remove.setAttribute('aria-label', this.labels.remove + ': ' + item.product_title);
          line.append(remove);
        }
        container.append(line);
      });
      this.querySelector('[data-cart-panel]').hidden = this.cart.items.length === 0;
      this.querySelector('[data-cart-total]').textContent = this.money(this.cart.total_price);
    }
    async onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const row = button.closest('[data-box-product]');
      if (row && (button.hasAttribute('data-preset') || button.hasAttribute('data-step'))) {
        const value = button.hasAttribute('data-preset') ? Number(button.dataset.preset) : this.quantity(row) + Number(button.dataset.step);
        row.querySelector('[data-quantity]').value = Math.min(999, Math.max(0, value));
        this.status('');
        this.render();
      } else if (row && button.hasAttribute('data-gallery-shortcut')) {
        row.querySelector('[data-gallery-open]').click();
      } else if (button.hasAttribute('data-add')) {
        const items = this.rows.filter(row => this.quantity(row) > 0).map(row => ({id: Number(row.dataset.variant), quantity: this.quantity(row)}));
        if (!items.length || button.disabled) return;
        await this.mutateCart('add', {items});
      } else if (button.hasAttribute('data-remove-key')) {
        await this.mutateCart('change', {id: button.dataset.removeKey, quantity: 0});
      }
    }
    async mutateCart(action, payload) {
      this.busy = true;
      this.status(action === 'add' ? this.labels.adding : this.labels.updating);
      this.render();
      this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.root + 'cart/' + action + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(Object.assign({}, payload, {sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname}))
        });
        const data = await response.json();
        if (action === 'add') this.rows.forEach(row => { row.querySelector('[data-quantity]').value = 0; });
        if (!response.ok) {
          await this.refreshCart();
          throw new Error(data.description || data.message || this.labels.error);
        }
        await this.refreshCart();
        this.updateThemeCart(data.sections);
        this.status(action === 'add' ? this.labels.added : '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'blitz-masking-order', cartData: this.cart});
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      } catch (error) {
        this.status(error.message === 'cart' ? this.labels.error : error.message);
      } finally {
        this.busy = false;
        this.render();
        this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = false; });
      }
    }
    updateThemeCart(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const destination = document.getElementById('CartDrawer');
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.toggle('is-empty', this.cart.items.length === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blitz-pvc-order"]) return;
  try {
    
if (!customElements.get('blitz-pvc-order')) {
  customElements.define('blitz-pvc-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.rows = Array.from(this.querySelectorAll('[data-box-product]'));
      this.byVariant = new Map(this.rows.map(row => [Number(row.dataset.variant), row]));
      this.cart = {items: [], total_price: 0, currency: this.dataset.currency || 'MXN'};
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.busy = false;
      this.ready = false;
      this.money = value => new Intl.NumberFormat((document.documentElement.lang || 'es-MX').toLowerCase().startsWith('es') ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.cart.currency || 'MXN'}).format(value / 100);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity]')) {
          event.target.value = Math.min(999, Math.max(0, Math.floor(Number(event.target.value) || 0)));
          this.render();
        }
      });
      this.render();
      this.refreshCart().catch(() => this.status(this.labels.error));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'blitz-pvc-order') this.refreshCart().catch(() => this.status(this.labels.error));
        });
      }
      this.pageShow = () => this.refreshCart().catch(() => this.status(this.labels.error));
      window.addEventListener('pageshow', this.pageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShow);
    }
    status(message) { this.querySelector('[data-status]').textContent = message; }
    boxLabel(count) { return count === 1 ? this.labels.box : this.labels.boxes; }
    countLabel(label, count) { return label.replace('[count]', String(count)).replace('[boxes]', this.boxLabel(count)); }
    quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
    existing(row) {
      return this.cart.items.filter(item => Number(item.variant_id) === Number(row.dataset.variant)).reduce((sum, item) => sum + item.quantity, 0);
    }
    async refreshCart() {
      const response = await fetch(this.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cart = await response.json();
      this.ready = true;
      this.renderCart();
      this.render();
      try {
        const sectionsResponse = await fetch(this.root + '?sections=cart-icon-bubble', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
        if (sectionsResponse.ok) this.updateThemeCart(await sectionsResponse.json());
      } catch (error) {}
    }
    render() {
      let boxes = 0, rolls = 0, subtotal = 0, selected = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        boxes += total;
        selected += qty;
        rolls += total * Number(row.dataset.rolls);
        subtotal += total * Number(row.dataset.price);
        if (qty > 0 && total > Number(row.dataset.stock)) invalid = true;
      });
      const percent = boxes >= 10 ? 10 : boxes >= 5 ? 5 : 0;
      let savings = 0;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        const rowAmount = total * Number(row.dataset.price);
        savings += Math.round(rowAmount * percent / 100);
        const amount = qty * Number(row.dataset.price);
        const payable = amount - Math.round(amount * percent / 100);
        const casePrice = Number(row.dataset.price);
        const discountedCase = casePrice - Math.round(casePrice * percent / 100);
        row.classList.toggle('is-selected', qty > 0 || existing > 0);
        row.querySelector('[data-unit-price]').textContent = this.money(discountedCase / Number(row.dataset.rolls));
        row.querySelector('[data-box-price]').textContent = this.money(discountedCase);
        row.querySelector('[data-unit-regular]').textContent = this.money(casePrice / Number(row.dataset.rolls));
        row.querySelector('[data-unit-regular]').hidden = percent === 0;
        row.querySelector('[data-unit-discount]').textContent = '−' + percent + '%';
        row.querySelector('[data-unit-discount]').hidden = percent === 0;
        row.querySelector('[data-line-total]').hidden = qty === 0;
        row.querySelector('[data-line-count]').textContent = qty + ' ' + this.boxLabel(qty) + ' · ' + (qty * Number(row.dataset.rolls)).toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
        row.querySelector('[data-line-price]').textContent = this.money(payable);
        const selectedPreset = total >= 10 ? 10 : total >= 5 ? 5 : total > 0 ? 1 : 0;
        row.querySelectorAll('[data-preset]').forEach(button => {
          const preset = Number(button.dataset.preset);
          const candidateBoxes = boxes - qty + preset;
          const candidatePercent = candidateBoxes >= 10 ? 10 : candidateBoxes >= 5 ? 5 : 0;
          button.setAttribute('aria-pressed', String(selectedPreset === preset));
          const discountLabel = button.querySelector('[data-preset-discount]');
          discountLabel.textContent = candidatePercent ? '−' + candidatePercent + '%' : '';
          discountLabel.hidden = candidatePercent === 0;
          button.setAttribute('aria-label', candidatePercent ? this.countLabel(this.labels.progressText, preset).replace('[percent]', String(candidatePercent)) : preset + ' ' + this.boxLabel(preset));
        });
        const stock = Number(row.dataset.stock);
        const stockMessage = row.querySelector('[data-stock-message]');
        const exceeded = qty > 0 && total > stock;
        stockMessage.classList.toggle('is-error', exceeded);
        stockMessage.textContent = (stock === 0 ? this.labels.outOfStock : exceeded ? this.countLabel(this.labels.available, Math.max(0, stock - existing)) : '') + (existing ? ' ' + this.countLabel(this.labels.inCart, existing) : '');
        stockMessage.hidden = !stockMessage.textContent.trim();
      });
      this.querySelector('[data-selection-count]').textContent = boxes + ' ' + this.boxLabel(boxes) + ' · ' + rolls.toLocaleString(document.documentElement.lang || 'es-MX') + ' ' + this.labels.rolls;
      this.querySelector('[data-discount-current]').textContent = percent + '%';
      this.querySelector('[data-mobile-discount]').textContent = boxes + ' ' + this.boxLabel(boxes) + (percent ? ' · −' + percent + '%' : '');
      const progress = this.querySelector('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(boxes, 10)));
      progress.setAttribute('aria-valuetext', this.countLabel(this.labels.progressText, boxes).replace('[percent]', String(percent)));
      this.querySelector('[data-progress-fill]').style.width = Math.min(boxes, 10) * 10 + '%';
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const current = Number(tier.dataset.tier) === percent;
        tier.classList.toggle('is-current', current);
        if (current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      this.querySelector('[data-savings-row]').hidden = percent === 0;

      this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
      this.querySelector('[data-discount-label]').textContent = this.labels.savings + ' (' + percent + '%)';
      this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
      this.querySelector('[data-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-mobile-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-next-tier]').textContent = boxes >= 10 ? this.labels.bestTier : boxes >= 5 ? this.countLabel(this.labels.moreForTen, 10 - boxes) : this.countLabel(this.labels.moreForFive, 5 - boxes);
      this.querySelector('[data-add]').disabled = this.busy || !this.ready || selected === 0 || invalid;
      this.querySelector('[data-checkout]').disabled = this.busy || this.cart.items.length === 0 || selected > 0;
      this.querySelector('[data-pending-note]').hidden = selected === 0;
      this.querySelectorAll('[data-quantity], [data-preset], [data-step]').forEach(control => { control.disabled = this.busy; });
      if (!this.busy && invalid) this.status(this.labels.stockError);
      else if (!this.busy && this.querySelector('[data-status]').textContent === this.labels.stockError) this.status('');
    }
    renderCart() {
      const container = this.querySelector('[data-cart-lines]');
      container.replaceChildren();
      this.cart.items.forEach(item => {
        const row = this.byVariant.get(Number(item.variant_id));
        const line = document.createElement('div');
        line.className = 'pvc-order__cart-line';
        const title = document.createElement('p');
        title.textContent = item.product_title;
        const quantity = document.createElement('p');
        quantity.textContent = item.quantity + ' ' + (row ? this.boxLabel(item.quantity) + ' · ' + item.quantity * Number(row.dataset.rolls) + ' ' + this.labels.rolls : this.labels.quantity) + ' · ' + this.money(item.final_line_price);
        line.append(title, quantity);
        if (row) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.labels.remove;
          remove.setAttribute('aria-label', this.labels.remove + ': ' + item.product_title);
          line.append(remove);
        }
        container.append(line);
      });
      this.querySelector('[data-cart-panel]').hidden = this.cart.items.length === 0;
      this.querySelector('[data-cart-total]').textContent = this.money(this.cart.total_price);
    }
    async onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const row = button.closest('[data-box-product]');
      if (row && (button.hasAttribute('data-preset') || button.hasAttribute('data-step'))) {
        const value = button.hasAttribute('data-preset') ? Number(button.dataset.preset) : this.quantity(row) + Number(button.dataset.step);
        row.querySelector('[data-quantity]').value = Math.min(999, Math.max(0, value));
        this.status('');
        this.render();
      } else if (row && button.hasAttribute('data-gallery-shortcut')) {
        row.querySelector('[data-gallery-open]').click();
      } else if (button.hasAttribute('data-add')) {
        const items = this.rows.filter(row => this.quantity(row) > 0).map(row => ({id: Number(row.dataset.variant), quantity: this.quantity(row)}));
        if (!items.length || button.disabled) return;
        await this.mutateCart('add', {items});
      } else if (button.hasAttribute('data-remove-key')) {
        await this.mutateCart('change', {id: button.dataset.removeKey, quantity: 0});
      }
    }
    async mutateCart(action, payload) {
      this.busy = true;
      this.status(action === 'add' ? this.labels.adding : this.labels.updating);
      this.render();
      this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.root + 'cart/' + action + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(Object.assign({}, payload, {sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname}))
        });
        const data = await response.json();
        if (action === 'add') this.rows.forEach(row => { row.querySelector('[data-quantity]').value = 0; });
        if (!response.ok) {
          await this.refreshCart();
          throw new Error(data.description || data.message || this.labels.error);
        }
        await this.refreshCart();
        this.updateThemeCart(data.sections);
        this.status(action === 'add' ? this.labels.added : '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'blitz-pvc-order', cartData: this.cart});
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      } catch (error) {
        this.status(error.message === 'cart' ? this.labels.error : error.message);
      } finally {
        this.busy = false;
        this.render();
        this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = false; });
      }
    }
    updateThemeCart(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const destination = document.getElementById('CartDrawer');
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.toggle('is-empty', this.cart.items.length === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blitz-wat-order"]) return;
  try {
    
if (!customElements.get('blitz-wat-order')) {
  customElements.define('blitz-wat-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.rows = Array.from(this.querySelectorAll('[data-box-product]'));
      this.byVariant = new Map(this.rows.map(row => [Number(row.dataset.variant), row]));
      this.cart = {items: [], total_price: 0, currency: this.dataset.currency || 'MXN'};
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.busy = false;
      this.ready = false;
      this.money = value => new Intl.NumberFormat((document.documentElement.lang || 'es-MX').toLowerCase().startsWith('es') ? 'es-MX' : document.documentElement.lang, {style: 'currency', currency: this.cart.currency || 'MXN'}).format(value / 100);
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity]')) {
          event.target.value = Math.min(999, Math.max(0, Math.floor(Number(event.target.value) || 0)));
          this.render();
        }
      });
      this.render();
      this.refreshCart().catch(() => this.status(this.labels.error));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'blitz-wat-order') this.refreshCart().catch(() => this.status(this.labels.error));
        });
      }
      this.pageShow = () => this.refreshCart().catch(() => this.status(this.labels.error));
      window.addEventListener('pageshow', this.pageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShow);
    }
    status(message) { this.querySelector('[data-status]').textContent = message; }
    boxLabel(count) { return count === 1 ? this.labels.box : this.labels.boxes; }
    countLabel(label, count) { return label.replace('[count]', String(count)).replace('[boxes]', this.boxLabel(count)); }
    quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
    existing(row) {
      return this.cart.items.filter(item => Number(item.variant_id) === Number(row.dataset.variant)).reduce((sum, item) => sum + item.quantity, 0);
    }
    async refreshCart() {
      const response = await fetch(this.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cart = await response.json();
      this.ready = true;
      this.renderCart();
      this.render();
    }
    render() {
      let boxes = 0, rolls = 0, subtotal = 0, selected = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        boxes += total;
        selected += qty;
        rolls += total * Number(row.dataset.rolls);
        subtotal += total * Number(row.dataset.price);
        if (qty > 0 && total > Number(row.dataset.stock)) invalid = true;
      });
      const percent = boxes >= 10 ? 10 : boxes >= 5 ? 5 : 0;
      let savings = 0;
      this.rows.forEach(row => {
        const qty = this.quantity(row);
        const existing = this.existing(row);
        const total = qty + existing;
        const rowAmount = total * Number(row.dataset.price);
        savings += Math.round(rowAmount * percent / 100);
        const amount = qty * Number(row.dataset.price);
        const payable = amount - Math.round(amount * percent / 100);
        const casePrice = Number(row.dataset.price);
        const discountedCase = casePrice - Math.round(casePrice * percent / 100);
        row.classList.toggle('is-selected', qty > 0 || existing > 0);
        row.querySelector('[data-unit-price]').textContent = this.money(discountedCase / Number(row.dataset.rolls));
        row.querySelector('[data-box-price]').textContent = this.money(discountedCase);
        row.querySelector('[data-unit-regular]').textContent = this.money(casePrice / Number(row.dataset.rolls));
        row.querySelector('[data-unit-regular]').hidden = percent === 0;
        row.querySelector('[data-unit-discount]').textContent = '−' + percent + '%';
        row.querySelector('[data-unit-discount]').hidden = percent === 0;
        row.querySelector('[data-line-total]').hidden = qty === 0;
        row.querySelector('[data-line-count]').textContent = qty + ' ' + this.boxLabel(qty) + ' · ' + qty * Number(row.dataset.rolls) + ' ' + this.labels.rolls;
        row.querySelector('[data-line-price]').textContent = this.money(payable);
        const selectedPreset = qty >= 10 ? 10 : qty >= 5 ? 5 : qty > 0 ? 1 : 0;
        row.querySelectorAll('[data-preset]').forEach(button => {
          const preset = Number(button.dataset.preset);
          const candidateBoxes = boxes - qty + preset;
          const candidatePercent = candidateBoxes >= 10 ? 10 : candidateBoxes >= 5 ? 5 : 0;
          button.setAttribute('aria-pressed', String(selectedPreset === preset));
          const discountLabel = button.querySelector('[data-preset-discount]');
          discountLabel.textContent = candidatePercent ? '−' + candidatePercent + '%' : '';
          discountLabel.hidden = candidatePercent === 0;
          button.setAttribute('aria-label', candidatePercent ? this.countLabel(this.labels.progressText, preset).replace('[percent]', String(candidatePercent)) : preset + ' ' + this.boxLabel(preset));
        });
        const stock = Number(row.dataset.stock);
        const stockMessage = row.querySelector('[data-stock-message]');
        const exceeded = qty > 0 && total > stock;
        stockMessage.classList.toggle('is-error', exceeded);
        stockMessage.textContent = (stock === 0 ? this.labels.outOfStock : exceeded ? this.countLabel(this.labels.available, Math.max(0, stock - existing)) : '') + (existing ? ' ' + this.countLabel(this.labels.inCart, existing) : '');
        stockMessage.hidden = !stockMessage.textContent.trim();
      });
      this.querySelector('[data-selection-count]').textContent = boxes + ' ' + this.boxLabel(boxes) + ' · ' + rolls + ' ' + this.labels.rolls;
      this.querySelector('[data-discount-current]').textContent = percent + '%';
      this.querySelector('[data-mobile-discount]').textContent = boxes + ' ' + this.boxLabel(boxes) + (percent ? ' · −' + percent + '%' : '');
      const progress = this.querySelector('[data-progress]');
      progress.setAttribute('aria-valuenow', String(Math.min(boxes, 10)));
      progress.setAttribute('aria-valuetext', this.countLabel(this.labels.progressText, boxes).replace('[percent]', String(percent)));
      this.querySelector('[data-progress-fill]').style.width = Math.min(boxes, 10) * 10 + '%';
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const current = Number(tier.dataset.tier) === percent;
        tier.classList.toggle('is-current', current);
        if (current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      this.querySelector('[data-savings-row]').hidden = percent === 0;

      this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
      this.querySelector('[data-discount-label]').textContent = this.labels.savings + ' (' + percent + '%)';
      this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
      this.querySelector('[data-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-mobile-total]').textContent = this.money(subtotal - savings);
      this.querySelector('[data-next-tier]').textContent = boxes >= 10 ? this.labels.bestTier : boxes >= 5 ? this.countLabel(this.labels.moreForTen, 10 - boxes) : this.countLabel(this.labels.moreForFive, 5 - boxes);
      this.querySelector('[data-add]').disabled = this.busy || !this.ready || selected === 0 || invalid;
      this.querySelector('[data-checkout]').disabled = this.busy || this.cart.items.length === 0 || selected > 0;
      this.querySelector('[data-pending-note]').hidden = selected === 0;
      this.querySelectorAll('[data-quantity], [data-preset], [data-step]').forEach(control => { control.disabled = this.busy; });
      if (!this.busy && invalid) this.status(this.labels.stockError);
      else if (!this.busy && this.querySelector('[data-status]').textContent === this.labels.stockError) this.status('');
    }
    renderCart() {
      const container = this.querySelector('[data-cart-lines]');
      container.replaceChildren();
      this.cart.items.forEach(item => {
        const row = this.byVariant.get(Number(item.variant_id));
        const line = document.createElement('div');
        line.className = 'wat-order__cart-line';
        const title = document.createElement('p');
        title.textContent = item.product_title;
        const quantity = document.createElement('p');
        quantity.textContent = item.quantity + ' ' + (row ? this.boxLabel(item.quantity) + ' · ' + item.quantity * Number(row.dataset.rolls) + ' ' + this.labels.rolls : this.labels.quantity) + ' · ' + this.money(item.final_line_price);
        line.append(title, quantity);
        if (row) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.labels.remove;
          remove.setAttribute('aria-label', this.labels.remove + ': ' + item.product_title);
          line.append(remove);
        }
        container.append(line);
      });
      this.querySelector('[data-cart-panel]').hidden = this.cart.items.length === 0;
      this.querySelector('[data-cart-total]').textContent = this.money(this.cart.total_price);
    }
    async onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const row = button.closest('[data-box-product]');
      if (row && (button.hasAttribute('data-preset') || button.hasAttribute('data-step'))) {
        const value = button.hasAttribute('data-preset') ? Number(button.dataset.preset) : this.quantity(row) + Number(button.dataset.step);
        row.querySelector('[data-quantity]').value = Math.min(999, Math.max(0, value));
        this.status('');
        this.render();
      } else if (button.hasAttribute('data-add')) {
        const items = this.rows.filter(row => this.quantity(row) > 0).map(row => ({id: Number(row.dataset.variant), quantity: this.quantity(row)}));
        if (!items.length || button.disabled) return;
        await this.mutateCart('add', {items});
      } else if (button.hasAttribute('data-remove-key')) {
        await this.mutateCart('change', {id: button.dataset.removeKey, quantity: 0});
      }
    }
    async mutateCart(action, payload) {
      this.busy = true;
      this.status(action === 'add' ? this.labels.adding : this.labels.updating);
      this.render();
      this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.root + 'cart/' + action + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(Object.assign({}, payload, {sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname}))
        });
        const data = await response.json();
        if (action === 'add') this.rows.forEach(row => { row.querySelector('[data-quantity]').value = 0; });
        if (!response.ok) {
          await this.refreshCart();
          throw new Error(data.description || data.message || this.labels.error);
        }
        await this.refreshCart();
        this.updateThemeCart(data.sections);
        this.status(action === 'add' ? this.labels.added : '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'blitz-wat-order', cartData: this.cart});
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      } catch (error) {
        this.status(error.message === 'cart' ? this.labels.error : error.message);
      } finally {
        this.busy = false;
        this.render();
        this.querySelectorAll('[data-remove-key]').forEach(button => { button.disabled = false; });
      }
    }
    updateThemeCart(sections) {
      if (!sections) return;
      const parser = new DOMParser();
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        const source = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const destination = document.getElementById('CartDrawer');
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.toggle('is-empty', this.cart.items.length === 0);
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.contactHeaderObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.contactHeaderObserver.observe(this.header);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.contactHeaderObserver?.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
